import cx from 'clsx';
import React from 'react';
import { useController } from 'react-hook-form';

import useTranslation from '@hooks/useTranslation';

import { ADD_AI_FIELDS } from '../../constants/schemaAddActionItem';
import style from './style.module.scss';

const aiOptionsList = [
  {
    value: 'requestInvestigation',
    title: 'Request an Investigation',
    description: 'Request an investigation into a facility asset or network equipment issue',
  },
  {
    value: 'reportFailure',
    title: 'Report a failure',
    description: 'Report a failure or malfunction of a facility asset or network equipment',
  },
];

const StepAIOption = ({ control }) => {
  const { t } = useTranslation();

  const {
    field: { value: optionValue, onChange: setOption },
    fieldState: { error },
  } = useController({ control, name: ADD_AI_FIELDS.OPTION });

  return (
    <>
      <div className={style.stepAiOption}>
        {aiOptionsList.map((option) => (
          <div
            key={option.value}
            className={cx(style.optionItem, { [style.optionItemSelected]: option.value === optionValue })}
            onClick={() => setOption(option.value)}
          >
            <div className={style.optionItemTitle}>{t(option.title)}</div>
            <div className={style.optionItemDescr}>{t(option.description)}</div>
          </div>
        ))}
      </div>
      <div className={style.helperText}>{error && t(error?.message)}</div>
    </>
  );
};

export default StepAIOption;
